var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.762,
    height: 15.471,
    viewBox: "0 0 13.762 15.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5888",
    "data-name": "Group 5888",
    transform: "translate(-27.12 -11.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M146.844,49.884l.807-1.272a.168.168,0,0,0-.027-.222.139.139,0,0,0-.2.052l-.839,1.321a4.655,4.655,0,0,0-3.628,0l-.839-1.321a.14.14,0,0,0-.2-.052.168.168,0,0,0-.027.222l.808,1.272a4.113,4.113,0,0,0-2.3,3.317h8.743a4.112,4.112,0,0,0-2.3-3.317",
    transform: "translate(-110.771 -37.316)",
    fill: "#9fbf3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M192.4,106.329a.525.525,0,1,1,.525-.525.525.525,0,0,1-.525.525",
    transform: "translate(-160.326 -91.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M140.4,175.489v6.465a.733.733,0,0,0,.766.7h.906v1.989a.98.98,0,0,0,1.951,0v-1.989h1.5v1.989a.98.98,0,0,0,1.95,0v-1.989h.906a.733.733,0,0,0,.766-.7v-6.465Z",
    transform: "translate(-110.768 -159.002)",
    fill: "#9fbf3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M79.56,179.47a.941.941,0,0,1-.943.938h0a.941.941,0,0,1-.943-.938v-3.8a.941.941,0,0,1,.943-.938h0a.941.941,0,0,1,.943.938Z",
    transform: "translate(-38.678 -158.877)",
    fill: "#9fbf3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M79.56,179.47a.941.941,0,0,1-.943.938h0a.941.941,0,0,1-.943-.938v-3.8a.941.941,0,0,1,.943-.938h0a.941.941,0,0,1,.943.938Z",
    transform: "translate(-50.554 -158.877)",
    fill: "#9fbf3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M192.4,106.329a.525.525,0,1,1,.525-.525.525.525,0,0,1-.525.525",
    transform: "translate(-156.476 -91.891)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android_icon.dd2f5f76101976f5917a7cafb5b5a689.svg";
export { ForwardRef as ReactComponent };